import { auAdministrativeAreas } from '@core/administrative-areas/au.areas';
import { SelectOption } from '@shared/form-fields/select/select.component';

export { isPostcodeInState } from '@core/administrative-areas/au.postcodes';

const administrativeAreasByCountry = {
	au: auAdministrativeAreas,
} as const;

export function getAdministrativeAreas(countryCode: string): SelectOption[] | null {
	return administrativeAreasByCountry[countryCode as keyof typeof administrativeAreasByCountry] ?? null;
}
